
export default class ProductFlagToggle {

  constructor(context = null) {
    if (context == document || context.classList.contains('flag-product-favorites')) {
      this.setup();
    }
  }

  setup() {

    const productFlagBtn = document.querySelector('.node-product .flag-product-favorites')
    if (productFlagBtn) {

      const catalogIcon = document.querySelector('.header .mycatalog-nav-count');
      // if (productFlagBtn.classList.contains('action-unflag')) {
      //
      // }

      if (catalogIcon) {
        productFlagBtn.querySelector('a').addEventListener('click', function (e) {
          console.log('trigger clickEvent', productFlagBtn.classList);
          const num = catalogIcon.textContent;
          if (productFlagBtn.classList.contains('action-unflag')) {
            catalogIcon.innerHTML = (parseInt(num) - 1).toString();
          } else {
            catalogIcon.innerHTML = (parseInt(num) + 1).toString();
          }
        })
      }
    }
  }

}
